import type { FC, ReactNode } from 'react';

import { FormattedMessage, defineMessages, useIntl } from 'dibs-react-intl';
import ChatAnimation from 'dibs-icons/exports/legacy/ChatAnimation';

import styles from './styles/PreChat.scss';

const messages = defineMessages({
    startLiveChat: {
        id: 'getHelp.liveChat.startLiveChat',
        defaultMessage: 'Start live chat',
    },
});

const PreChatContainer: FC<{ children: ReactNode }> = ({ children }) => (
    <div className={styles.container}>{children}</div>
);

const PreChatButton: FC<{ onClick: () => void; showLoadingAnimation?: boolean }> = ({
    onClick,
    showLoadingAnimation,
}) => {
    const { formatMessage } = useIntl();

    return (
        // eslint-disable-next-line react/forbid-elements
        <button
            className={styles.button}
            aria-label={formatMessage(messages.startLiveChat)}
            type="button"
            onClick={onClick}
        >
            <ChatAnimation className={styles.chatIcon} showAnimation={showLoadingAnimation} />
            <span className={styles.chatLabel}>
                <FormattedMessage id="getHelp.LiveChat.buttonText" defaultMessage="Support" />
            </span>
        </button>
    );
};

/**
 * `Pre-chat` button to match minimised SF chat button styles
 *
 * ```tsx
 * <PreChat.Container>
 *   <PreChat.Button />
 * </PreChat.Container>
 * ```
 */
const PreChat = {
    /**
     * Container that matches position of minimised SF chat button
     */
    Container: PreChatContainer,
    /**
     * Button that matches minimised SF chat button
     */
    Button: PreChatButton,
};

export default PreChat;
